module.exports = __webpack_public_path__ + "61394355ae2b9933fa042ccbe16a5a9a.svg";